import React, { Fragment } from "react";

import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import { Col, Container, Row } from "react-bootstrap";

const ThemeWrapper = (props) => {
  return (
    <Fragment>
      <Container>
        <Row>
          <Col lg={12}>
            <Header />
            <div className="main-content-conteiner">
              <div className="page-content">{props.children}</div>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Footer />
      </Container>
    </Fragment>
  );
};

export default ThemeWrapper;
